import React from "react";
import styles from "./styles.module.scss";
import StepperNavigationItem from "./components/StepperNavigationItem";
import PropTypes from "prop-types";

const StepperNavigation = ({ children, activeStepIndex }) => {
  return (
    <div className={styles.stepperNavigationWrapper}>
      {children?.map((item, index) => (
        <StepperNavigationItem
          title={item.props["data-nav"]}
          number={Number(index) + 1}
          key={index}
          active={index === activeStepIndex}
        />
      ))}
    </div>
  );
};

StepperNavigation.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  activeStepIndex: PropTypes.number
};

export default StepperNavigation;
